import { render, staticRenderFns } from "./QuestionModal.vue?vue&type=template&id=644c0a57&scoped=true"
import script from "./QuestionModal.vue?vue&type=script&lang=ts"
export * from "./QuestionModal.vue?vue&type=script&lang=ts"
import style0 from "./QuestionModal.vue?vue&type=style&index=0&id=644c0a57&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644c0a57",
  null
  
)

export default component.exports